import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  customTableCell: {
    "&.MuiTableCell-head:first-child": {
      borderTopLeftRadius: "0px",
      borderBottomLeftRadius: "0px",
      borderTopRightRadius: "0px",
      borderBottomRightRadius: "0px",
    },
  },
}));

interface MyTimesheetTableDayHeaderProps {
  date: string;
  dailySum: string | number;
}

export const MyTimesheetMyTimesheetTableDayHeader = ({
  date,
  dailySum,
}: MyTimesheetTableDayHeaderProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={classes.customTableCell}>
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="body1" style={{ fontWeight: 700 }}>
                  {date}
                </Typography>
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Typography variant="body1">{t("MY_TIMESHEET_DAILY_TOTAL")}:</Typography>
                  <Box width={"8px"} />
                  <Typography variant="body1" style={{ fontWeight: 700 }}>
                    {dailySum}
                  </Typography>
                </Box>
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
      </Table>
    </TableContainer>
  );
};

export default MyTimesheetMyTimesheetTableDayHeader;
